/* eslint-disable no-dupe-keys */
module.exports={
    messageConstants: {
      almeResponseType: 'AlmeResponseType',
      appeventRequest: 'AppeventRequest',
      converseRequest: 'ConverseRequest',
      getHistoryRequest: 'GetHistoryRequest',
      livechatConnectBanner: 'LiveChatConnectBanner',
      livechatDisconnectBanner: 'LiveChatDisconnectBanner',
      livechatInputType: 'LiveChatInputType',
      livechatResponseType: 'LiveChatResponseType',
      reportingEventRequest: 'ReportingEventRequest',
      userInputType: 'UserInputType',
    },
};


// WEBPACK FOOTER //
// ./settings/message-constan.js